import Vue from 'vue';
import Router from 'vue-router';
const HomeView = () => import('../components/views/HomeView.vue');
const SendPressageView = () => import('../components/views/SendPressageView.vue');
const PerfomanceView = () => import('../components/views/PerfomanceView.vue');
const MediaView = () => import('../components/views/MediaView.vue');
const SettingsView = () => import('../components/views/SettingsView.vue');
const InitialPasswordView = () => import('../components/views/InitialPasswordView.vue');
const FurgeLogin = () => import('../components/views/FurgeLogin.vue');
const InitialLoginView = () => import('../components/views/InitialLoginView.vue');
const PlaygroundView = () => import('../components/views/PlaygroundView.vue');
const ModuleView = () => import('../components/views/ModuleView.vue');
const ModuleRedirectView = () => import('../components/views/ModuleRedirectView.vue');
const OutsideView = () => import('../components/views/OutsideView.vue');
const PushwizeView = () => import('../components/views/PushwizeView.vue');

Vue.use(Router);

export default new Router({
    mode: 'history',
    routes: [{
        name: 'home',
        path: '/',
        component: HomeView,
    }, {
        name: 'send',
        path: '/send',
        component: {
            template: '<comp />',
            components: { 'comp': SendPressageView },
            key: 'send'
        },
    }, {
        name: 'sendModNews',
        path: '/send-news',
        component: {
            template: '<comp />',
            components: { 'comp': SendPressageView },
            key: 'send-news'
        },
    }, {
        name: 'perfomance',
        path: '/perfomance',
        component: PerfomanceView,
    }, {
        name: 'media',
        path: '/media',
        component: MediaView,
    }, {
        name: 'settings',
        path: '/settings',
        component: SettingsView,
    }, {
        name: 'initialPassword',
        path: '/initial-password/:token',
        component: InitialPasswordView,
        meta: {
            allowGuests: true,
        },
    }, {
        name: 'furgeLogin',
        path: '/furge/login',
        component: FurgeLogin,
        meta: {
            allowGuests: true,
        },
    }, {
        name: 'initialLogin',
        path: '/initial-login/:token',
        component: InitialLoginView,
        meta: {
            allowGuests: true,
        },
    }, {
        name: 'playground',
        path: '/playground',
        component: PlaygroundView,
    }, {
        name: 'module',
        path: '/module/:id',
        component: ModuleView,
    }, {
        name: 'module-redirect',
        path: '/module-redirect/:id',
        component: ModuleRedirectView,
    }, {
        name: 'outside',
        path: '/outside/:outUrl/:backRoute',
        component: OutsideView,
    }, {
        name: 'pushwize',
        path: '/pushwize',
        component: PushwizeView,
        meta: {
            allowGuests: true,
        },
    }],
});
